import React, {useState} from "react";
import AjaxFunctions from "../ajaxFunctions";
import Utils from "../utils";
import * as ToastAlert from "../components/toastAlert";
import {Button, Typography} from "@material-ui/core";
import {MultiLineTextField} from "../components/commonControls.jsx";
import {MPubCardSimple} from "../components/mPubCard";

export function RulesTab(props) {
   return (
      <div id={'rulesTab'}>
         <div>
            <img
               id={'dashBracketScreenshot'}
               src={'https://plexus-static.s3.us-west-2.amazonaws.com/unversioned/images/dashBracket1.png'}
               alt={'Screenshot of the published bracket'}
            />
            <div className={'header'}>
               Please note this is a screenshot of the published Brackets. <br />
               You must sign into Polyplexus to see the live Brackets and debate and vote on the submissions.
            </div>
         </div>
         <hr />
         <div className={'header'}>
            Eligibility
         </div>
         <div className={'body'}>
            {
               'The ARPA-H Dash is focused on exploring positive transformations in the health of Americans. '+
               'All those with a vested interest in American health are encouraged to participate through '+
               'transformation entries, discussion, and voting. The community includes, but is not limited to, ' +
               'healthcare professionals, researchers, entrepreneurs, healthcare grassroots organizations, ' +
               'patient advocates and patients themselves, health and health-related industry, etc. ' +
               '\n\n' +

               'Those who do not have a vested interest are encouraged to observe without participating actively. ' +
               '\n\n' +

               'Aixxia, owner of the Polyplexus platform, reserves the right to restrict network connections ' +
               'from outside the U.S., but we do not intend to do so unless participants fail to respect the ' +
               'intent of the event. ' +
               '\n\n' +

               'To receive any prize the winner MUST be able to provide a U.S. Taxpayer Identification Number ' +
               'and Certification by completing and signing Internal Revenue Service Form W-9. ' +
               '\n\n' +

               'See the Terms and Conditions: Additional Terms and Conditions section for additional eligibility requirements.'
            }
         </div>

         <div className={'header'}>
            Rules
         </div>
         <div className={'body'}>
            {
'All deadlines are firm. Late entries will not be considered. Late votes will not be counted. ' +
               'Participation requires signing up on the free-to-use Polyplexus platform. ' +
               '\n\n ' +
               'Professional standards of conduct are expected in all entries and discussions. All participants ' +
               'are responsible for fostering an atmosphere of mutual respect during the event. ' +
               '\n\n ' +
               'The Polyplexus facilitator monitors all posts and discussions. Aixxia reserves the right to block a ' +
               'participant if, in the sole judgement of Aixxia, the participant is not fostering an atmosphere of ' +
               'mutual respect. ' +
               '\n\n ' +
               'Participants must use only one Polyplexus account for all their activity in the ARPA-H Dash to ' +
               'Accelerate Health Outcomes. ' +
               '\n\n ' +
               'Up to two transformation submissions per participant are allowed. ' +
               '\n\n ' +
               'Submission of one piece of supporting evidence is required for each entry, typically in the form ' +
               'of a citation. Preferred citations for supporting evidence are refereed journal publications. ' +
               'Preprints, technical articles, and other reputable sources of information are acceptable. The ' +
               'publication or posting date of the evidence submitted must be on or after January 1, 2018. ' +
               '\n\n ' +
               'Aixxia reserves the right to adjust rules without notice if it is necessary to do so to effectively ' +
               'manage the event. ' +
               '\n\n ' +
               'Entries and discussion posts remain the property of the submitter, but the submitter grants ' +
               'Aixxia a perpetual license to maintain the entries and posts on the web site and to use them in ' +
               'promotional materials. Posting copyrighted material is not permitted.'
            }
         </div>
         <div className={'header'}>
            Judging Criteria
         </div>
         <div className={'body'}>
            {
'A panel of three subject matter experts (SMEs) selected by ARPA-H will review all entries and ' +
               'select the 64 accepted entries based upon the following criteria: ' +
               '\n\n ' +
               '--General quality of the entry. General quality criteria are clarity of the written entry, the ' +
               'quality of the attached evidence (for example, peer-reviewed citations are preferred over ' +
               'magazine articles), the novelty of the transformation idea, and the technical merit. ' +
               '\n\n ' +
               '--Identification of duplicate or near-duplicate transformations. The SME panel will deliver a ' +
               '64-entry field with maximum technical and ideation breadth, which may require narrowing ' +
               'the field by removing transformations that are very similar. If duplicate transformations are ' +
               'nominated the date of submission will be used to select the bracket entry. ' +
               '\n\n ' +
               '--The ARPA-H Dash organizers reserve the right to accept a later submission over an earlier ' +
               'one, provided both are within the submission deadline, if the later entry significantly ' +
               'broadens the diversity of ideas within the bracket. ' +
               '\n\n ' +
               'All decisions of the SME panel on entry selection and seeding are final. ' +
               '\n\n ' +
               'Declined entries will be notified via email. ' +
               '\n\n ' +
               'Seeding will be completed by the SME panel with the goal of distributing the strongest ' +
               'transformations across the bracket so that these entries meet after rounds 1 and 2. ' +
               '\n\n ' +
               'Judges will review the entries after each round of public voting, and judges make the final ' +
               'decision on who advances to the next round, subject to approval each round by the agency’s ' +
               'award approving official. The voting outcomes and the discussion content will be reviewed ' +
               'and considered by the SME panel (aka the Judges) prior to the advancement decision.'
            }

         </div>
         <div className={'header'}>
            Terms And Conditions
         </div>
         <div className={'body'}>
            {
               'ARPA-H reserves the right to modify these terms at any time, and changes are effective ' +
               'immediately upon posting. By using the Polyplexus.com platform, users agree to all of the ' +
               'terms specified herein. Failure to fully comply with the terms of use or any related laws, rules ' +
               'and regulations may result in denial of use or access to Polyplexus.com. ' +
               '\n\n ' +
               'The ARPA-H Dash to Accelerate Health Outcomes is an online contest sponsored by the ' +
               'Advanced Research Projects Agency - Health (ARPA-H) through the Polyplexus cloud platform ' +
               'owned and operated by a third-party contractor, Aixxia LLC. ARPA-H neither guarantees nor ' +
               'warrants that information posted on Polyplexus.com by agency Dash managers or other site ' +
               'users is correct and disclaims any liability for any loss or damage resulting from reliance on any ' +
               'such information.'
            }
         </div>
         <div className={'sub-header'}>
            Participants
         </div>
         <div className={'body'}>
            {
               'Participants will have access to the ARPA-H Dash to Accelerate Health Outcomes for the ' +
               'duration of the Dash. ' +
               '\n\n ' +
               'Participant must have a Polyplexus account to use the services and is responsible for the ' +
               'information it provides to create the account, the security of its passwords for the account, and ' +
               'for any use of its account. Use of multiple accounts to circumvent the terms of the Dash is a ' +
               'violation of the User Agreement and will result in loss of access to the platform and ' +
               'disqualification from the Dash.'
            }
         </div>
         <div className={'sub-header'}>
            Privacy
         </div>
         <div className={'body'}>
            {
               'All accepted entries, posted brackets, posted comments, contest results, and names of prize ' +
               'winners in the ARPA-H Dash to Accelerate Health Outcomes will be posted on the public ' +
               'Polyplexus online platform and may be used in promotional material.'
            }
         </div>
         <div className={'sub-header'}>
            Intellectual Property and Copyright
         </div>
         <div className={'body'}>
            {
               'Posting of copyrighted material or proprietary intellectual property outside of allowable uses is ' +
               'a violation of the user agreement and will result in removal of the material and may result in ' +
               'cancellation of platform account. ' +
               '\n\n ' +
               'Entries and discussion posts remain the property of the submitter, but the submitter grants ' +
               'Aixxia a license in perpetuity to maintain the entries and posts on the website and to use them  ' +
               'in promotional materials.'
            }
         </div>
         <div className={'sub-header'}>
            Prize Qualification and Taxes
         </div>
         <div className={'body'}>
            {
               'Participant is responsible for any taxes accrued through prize awards from the ARPA-H Dash to ' +
               'Accelerate Health Outcomes. ' +
               '\n\n ' +
               'Participant will provide any applicable tax identification information that may be required ' +
               'under applicable law to ensure compliance with applicable tax regulations and authorities in ' +
               'applicable jurisdictions. ' +
               '\n\n ' +
               'Participant will be liable to pay any taxes, interest, penalties, or fines arising out of any mis-' +
               'declaration by Participant. ' +
               '\n\n ' +
               'By accepting a prize, the Participant grants ARPA-H and Aixxia the right to use their name in ' +
               'public announcements of the contest results.'
            }
         </div>
         <div className={'sub-header'}>
            Participant Suspension
         </div>
         <div className={'body'}>
            {
               'Aixxia may immediately suspend all or part of Participant\'s use of the online platform Services if ' +
               '(a) Aixxia reasonably believes Participant\'s or any End User\'s use of the Services could adversely ' +
               'impact the Services, other participants\'s use of the Services, or the Aixxia network or servers ' +
               'used to provide the Services; (b) there is suspected unauthorized third-party access to the ' +
               'Services; (c) Aixxia reasonably believes that immediate suspension is required to comply with ' +
               'any applicable law; or (d) Participant is in breach of these Terms and Conditions or the User ' +
               'Agreement. Aixxia will lift any such Suspension when the circumstances giving rise to the ' +
               'Suspension have been resolved. At Participant\'s request, Aixxia will, unless prohibited by ' +
               'applicable law, notify Participant of the basis for the Suspension as soon as is reasonably ' +
               'possible.'
            }
         </div>
         <div className={'sub-header'}>
            Additional Terms & Conditions
         </div>
         <div className={'body'}>
            {
               '(1) To be eligible to win a prize under the Dash, a Participant (whether an individual, group of ' +
               'individuals, or entity) — ' +
               '\n\n ' +
               'a. Shall have registered to participate in the Dash under the rules promulgated by ARPA-H ' +
               'as published in this announcement; ' +
               '\n\n ' +
               'b. Shall have complied with all the requirements set forth in this announcement; ' +
               '\n\n ' +
               'c. In the case of a private entity, shall be incorporated in and maintain a primary place of ' +
               'business in the United States, and in the case of an individual, whether participating singly or in ' +
               'a group, shall be a citizen or permanent resident of the United States; however, non-U.S. ' +
               'citizens and non-permanent residents can participate as a member of a team that otherwise ' +
               'satisfies the eligibility criteria. Non-U.S. citizens and non-permanent residents are not eligible to ' +
               'win a monetary prize (in whole or in part). Their participation as part of a winning team, if ' +
               'applicable, may be recognized when the results are announced. ' +
               '\n\n ' +
               'd. May not be a Federal entity or Federal employee acting within the scope of their ' +
               'employment; ' +
               '\n\n ' +
               'e. May not be a Federal employee of the Department of Health and Human Services) (or ' +
               'any other component of HHS including ARPA-H) acting in their personal capacity; ' +
               '\n\n ' +
               'f. Who is employed by a Federal agency or entity other than HHS (or any component of ' +
               'HHS), should consult with an agency Ethics Official to determine whether the Federal ethics ' +
               'rules will limit or prohibit the acceptance of a prize under this Challenge; ' +
               '\n\n ' +
               'g. May not be a judge of the Challenge, or any other party involved with the design, ' +
               'production, execution, or distribution of the Challenge or the immediate family of such a party ' +
               '(i.e., spouse, parent, step-parent, child, or step-child). ' +
               '\n\n ' +
               '(2) Federal grantees may not use Federal funds to develop their Dash entries unless use of such ' +
               'funds is consistent with the purpose of their grant award and specifically requested to do so ' +
               'due to the Dash design as described in this announcement. Federal grantees who use Federal ' +
               'funds to develop their Dash entries must also obtain written prior approval from the ' +
               'appropriate grants management or program officer and provide documentation of prior ' +
               'approval upon request by HHS. ' +
               '\n\n ' +
               '(3) Federal contractors may not use Federal funds from a contract to develop their Dash entries ' +
               'or to fund efforts in support of their Dash entries. ' +
               '\n\n ' +
               '(4) Entries must not infringe upon any copyright or any other rights of any third party. ' +
               '\n\n ' +
               '(5) By participating in this Dash, each Participant (whether an individual, group of individuals, or ' +
               'entity) agrees to assume any and all risks and waive claims against the Federal government and ' +
               'its related entities (as defined in the America COMPETES Reauthorization Act, as amended), ' +
               'except in the case of willful misconduct, for any injury, death, damage, or loss of property, ' +
               'revenue, or profits, whether direct, indirect, or consequential, arising from participation in this ' +
               'Dash, whether the injury, death, damage, or loss arises through negligence or otherwise. ' +
               '\n\n ' +
               '(6) Based on the subject matter of the Dash, the type of work that it will possibly require, as ' +
               'well as an analysis of the likelihood of any claims for death, bodily injury, property damage, or ' +
               'loss potentially resulting from Dash participation, no Participant (whether an individual, group ' +
               'of individuals, or entity) participating in the Dash is required to obtain liability insurance or ' +
               'demonstrate financial responsibility in order to participate in this Dash. ' +
               '\n\n ' +
               '(7) By participating in this Dash, each Participant (whether an individual, group of individuals, or ' +
               'entity) agrees to indemnify the Federal government against third party claims for damages ' +
               'arising from or related to Dash activities. ' +
               '\n\n ' +
               '(8) A Participant (whether an individual, group of individuals, or entity) shall not be deemed ' +
               'ineligible because the Participant used Federal facilities or consulted with Federal employees ' +
               'during the Dash if the facilities and employees are made available to all Participants ' +
               'participating in the Dash on an equitable basis. ' +
               '\n\n ' +
               '(9) By participating in this Dash, each Participant (whether an individual, group of individuals, or ' +
               'entity) warrants that he, she, or it is the sole author or owner of, or has the right to use, any ' +
               'copyrightable works that the entry comprises, that the works are wholly original with the ' +
               'Participant (or is an improved version of an existing work that the Participant has sufficient ' +
               'rights to use and improve), and that the entry does not infringe any copyright or any other ' +
               'rights of any third party of which the Participant is aware. ' +
               '\n\n ' +
               '(10) ARPA-H reserves the right, in its sole discretion, to (a) cancel, suspend, or modify the Dash, ' +
               'and/or (b) not award any prizes if no entries are deemed worthy. ' +
               '\n\n ' +
               '(11) Each Participant (whether an individual, group of individuals, or entity) agrees to follow all ' +
               'applicable federal, state, and local laws, regulations, and policies. ' +
               '\n\n ' +
               '(12) Each Participant (whether an individual, group of individuals, or entity) participating in this ' +
               'Dash must comply with all terms and conditions of these rules, and participation in this Dash ' +
               'constitutes each such Participant’s full and unconditional agreement to abide by these rules. ' +
               'Winning is contingent upon fulfilling all requirements herein.'
            }
         </div>
      </div>
   )
}